"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersViewPure = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_redux_1 = require("react-redux");
var connected_react_router_1 = require("connected-react-router");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var react_router_dom_1 = require("react-router-dom");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var ProjectHomeActions = require("@caddigital/sok-reducers/lib/actions/project/home");
var OrderListActions = require("@caddigital/sok-reducers/lib/actions/order/list");
var Types = require("types");
var SearchBar_1 = require("./SearchBar");
var ListContainer_1 = require("./ListContainer");
var Tools_1 = require("./Tools");
var translate_1 = require("utils/translate");
require("./style.scss");
var mapStateToProps = function (_state) { return ({}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    clear: function () { return dispatch(OrderListActions.clear()); },
    setProject: function (projectId) { return function () {
        return dispatch(ProjectHomeActions.fetchProjectByIdRequest(projectId));
    }; },
    fetchOrderList: function (folder) { return function () {
        return dispatch(OrderListActions.fetchOrderListRequest(folder, 'only-my'));
    }; },
    navigateToProject: function (lang, project) {
        dispatch(FilesActions.resetSortOptionsAction());
        dispatch(FilesActions.resetSearchOptionsAction());
        dispatch((0, connected_react_router_1.push)("/".concat(lang, "/projects/").concat(project.id, "/orders")));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#region Types
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
//#endregion
var OrdersViewPure = function (props) { return (React.createElement("div", { className: 'content-wrapper-content' },
    React.createElement("div", { className: 'orders-view' },
        React.createElement("main", { className: 'content' },
            React.createElement(sok_ui_1.BreadCrumb, null,
                React.createElement(react_router_dom_1.Link, { to: "/".concat((0, translate_1.getLanguage)(), "/projects/").concat(props.currentProject.id) }, props.currentProject.name),
                React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/projectname/orders'))),
            React.createElement(SearchBar_1.SearchBar, { navigateToProject: props.navigateToProject, currentProject: props.currentProject }),
            React.createElement(Tools_1.Tools, { currentFolder: props.currentFolder, currentProject: props.currentProject }),
            React.createElement(ListContainer_1.ListContainer, { currentFolder: props.currentFolder, currentProject: props.currentProject }))))); };
exports.OrdersViewPure = OrdersViewPure;
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetchOrderList(this.props.currentFolder)();
    },
    componentWillReceiveProps: function (nextProps) {
        // if (nextProps.currentFolder !== this.props.currentFolder) {
        //  nextProps.fetchOrderList(nextProps.currentFolder)
        // }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
exports.default = enhance(exports.OrdersViewPure);
